import { Button as ButtonPrimitive } from '@base-ui/react/button';

import { cn } from '../../lib/utils';
import { iconButtonVariants } from './variants';

export const IconButton = ({
  className,
  ...props
}: ButtonPrimitive.Props) => {
  return (
    <ButtonPrimitive
      data-slot={'icon-button'}
      className={cn(iconButtonVariants(), className)}
      {...props}
    >
      {props.children}
    </ButtonPrimitive>
  );
};
